import { Icon, IconsEnum } from 'components/Icons';
import React, { useEffect, useState } from 'react';
import {
  resetFilterChecked,
  resetSingleFilterChecked,
  resetSingleQueryParam,
  setFilterChecked,
  setQueryParamList,
} from 'features/ippica/ippicaSlice';
import {
  selectDefaultItem,
  selectFiltersToday,
  selectIppicaTodayTablist,
  selectQueryParamList,
  selectQueryParamObjList,
} from 'features/ippica/selectors';

import { IppicaFiltersDialog } from '../ippicaFiltersDialog';
import { IppicaFiltersDialogRow } from '../ippicaFiltersDialog/ippicaFiltersDialogRow';
import { IppicaWithTabTable } from '../ippicaWithTabTable';
import { fetchAndUpdateData } from 'features/ippica/actions';
import styles from './IppicaWithTabContainer.module.scss';
import { useAppDispatch } from 'lib/centralStore';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export type IppicaWithTabContainerProps = {
  hasMarginBottom?: boolean;
  hasMarginRight?: boolean;
  containerClassName?: string;
};

export const IppicaWithTabContainer = ({
  hasMarginBottom,
  hasMarginRight,
  containerClassName,
}: IppicaWithTabContainerProps) => {
  const [isOpenFilters, setIsOpenFilters] = useState<boolean>(false);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isFilterApplyed, setIsFilterApplyed] = useState<boolean>(false);
  const labelReset = useGetLabelByKey('reset-filtri');
  const labelRisultati = useGetLabelByKey('mostra-risultati');
  const { isOpen } = useTypedSelector((state) => state.carrello);
  const queryParamListGroups = useTypedSelector(selectQueryParamObjList);
  const queryParamList = useTypedSelector(selectQueryParamList);
  const dispatch = useAppDispatch();

  const { isMobile } = useWindowSize();

  const filters = useTypedSelector(selectFiltersToday);
  const defaultItem = useTypedSelector(selectDefaultItem);
  const tabList = useTypedSelector(selectIppicaTodayTablist);

  const retrieveResults = (param: Array<{ [key: string]: string }>) => {
    dispatch(fetchAndUpdateData(param));
    setIsFilterApplyed(true);
    setIsOpenFilters(false);
  };
  const resetFilters = () => {
    dispatch(resetFilterChecked());
    setIsFetching(true);
    setIsFilterApplyed(false);
  };

  const handleRadioChange = (e: any, list: Array<{ label: string }>, indexRow: number) => {
    const activeIndex = list.findIndex((item) => {
      return item.label === e.target.value;
    });
    dispatch(setFilterChecked({ indexRow, indexValue: activeIndex }));
    dispatch(setQueryParamList({ indexRow, indexValue: activeIndex }));
  };

  const doRemoveSingleFilter = (filterParam: { [key: string]: string; label: string; queryGroup: string }) => {
    dispatch(resetSingleQueryParam({ group: filterParam.queryGroup }));
    dispatch(resetSingleFilterChecked({ label: filterParam.label, group: filterParam.queryGroup }));
    setIsFetching(true);
  };

  useEffect(() => {
    if (isFetching) {
      retrieveResults(queryParamList);
      setIsFetching(false);
      if (queryParamList.length === 0) {
        setIsFilterApplyed(false);
      }
    }
  }, [queryParamList, isFetching]);

  return (
    <>
      <section
        className={`${styles.container} ${containerClassName ? containerClassName : ''} ${
          hasMarginBottom ? styles.withMarginBottom : ''
        } ${!isOpen ? styles.withMarginRight : ''}`}
      >
        <h2 className={styles.title}>Corse di Oggi</h2>
        {!!tabList?.length && (
          <div className={styles.btnContainer}>
            {!isMobile && queryParamListGroups.length > 0 && isFilterApplyed && (
              <div className={styles.filterContainer}>
                {queryParamListGroups.map((filter, index) => {
                  return (
                    <button
                      type="button"
                      key={`${filter.label}_${index}`}
                      className={styles.filterBtn}
                      onClick={() => {
                        doRemoveSingleFilter(filter);
                      }}
                    >
                      {filter.label}
                      <Icon iconId={IconsEnum.CANCEL} className={styles.closeIcon} color="var(--color-primary)" />
                    </button>
                  );
                })}
                <button type="button" className={styles.resetBtn} onClick={() => resetFilters()}>
                  RESET
                </button>
              </div>
            )}
            <button className={styles.buttonFilter} onClick={() => setIsOpenFilters(true)}>
              <Icon iconId={IconsEnum.FILTER} className={styles.icon} color="var(--color-on-bg-secondary)" />
              {isFilterApplyed && !!queryParamList?.length && <span className={styles.dot} />}
            </button>
          </div>
        )}
        <IppicaWithTabTable />
      </section>

      <IppicaFiltersDialog
        open={isOpenFilters}
        defaultOpen={isOpenFilters}
        onOpenChange={setIsOpenFilters}
        title="Filtri"
      >
        <div className={styles.dialogContainer}>
          {filters.map((filter, index) => {
            return (
              <React.Fragment key={filter.label + '_' + index}>
                <IppicaFiltersDialogRow
                  todayFilter={filter}
                  indexRow={index}
                  defaultFilter={defaultItem[index]}
                  handleRadioChange={handleRadioChange}
                />
              </React.Fragment>
            );
          })}
        </div>
        {/* NOTE appare solo se vengono selezionati dei filtri? */}
        <div className={styles.footer}>
          <button
            type="button"
            disabled={!queryParamList.length}
            className={styles.reset}
            onClick={() => resetFilters()}
          >
            {labelReset}
          </button>

          <button
            className={styles.dismiss}
            disabled={!queryParamList.length}
            type="button"
            onClick={() => retrieveResults(queryParamList)}
          >
            {labelRisultati}
          </button>
        </div>
      </IppicaFiltersDialog>
    </>
  );
};
